import { httpRequest } from '@calendly/http-tools'

const apiPath = ({ id, profile, owner_type: ownerType, owner_id: ownerId }) => {
  switch (ownerType) {
    case 'User':
      return `/api/users/${ownerId ?? profile.owner_id}/event_types/${id}`
    case 'Organization':
      return `/api/organization/event_types/${id}`
    default:
      return null
  }
}

export const fetchEventType = (eventType) => httpRequest({
  url: apiPath(eventType),
  method: 'GET'
})

export const updateEventType = (eventType, payload) => httpRequest({
  url: apiPath(eventType),
  method: 'PATCH',
  data: payload
})
